import React from 'react'
import ReactApexChart from 'react-apexcharts';

interface Props<TypeRadialBarChart> {
    chartData: number[];
    chartLabels: string[];
    title?: string;
    height?: number;
    color?: string[];
}

export default function RadialBar<TypeRadialBarChart>({ chartData, chartLabels, title, height, color }: Props<TypeRadialBarChart>) {

    const data = {

        series: chartData || [],
        options: {
            chart: {
                // height: 350,
                // type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '40%',
                    }
                },
            },
            labels: chartLabels || [],
            title: {
                text: title || '',
                // align: 'left'
            },
            colors: color || ['#055DC9', '#008000'],
            legend: {
                show: false,
              },
        },

    };

    return (
        <React.Fragment>
            <ReactApexChart options={data.options} series={data.series} type="radialBar" height={height || 350} />
        </React.Fragment>
    )
}
